import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./Stepper.module.css";
const TONE_BAR_CLASS = {
    accent: styles.toneAccent ?? "",
    success: styles.toneSuccess ?? "",
    danger: styles.toneDanger ?? "",
};
const TONE_NAME_CLASS = {
    accent: styles.nameToneAccent ?? "",
    success: styles.nameToneSuccess ?? "",
    danger: styles.nameToneDanger ?? "",
};
/**
 * Stepper — metáfora de barras para estágios sequenciais (Onda D).
 * Cada passo é uma coluna com uma barra fina no topo (done/current/upcoming)
 * e o rótulo abaixo, em uppercase espaçado. Puramente apresentacional —
 * a semântica de negócio (o que cada passo dispara ao ser clicado) é do
 * consumidor via `onStepClick`.
 */
export function Stepper({ steps, onStepClick, ariaLabel = "Estágios", className }) {
    return (_jsx("ol", { role: "list", "aria-label": ariaLabel, className: [styles.stepper, className ?? ""].filter(Boolean).join(" "), children: steps.map((step, index) => {
            const tone = step.tone ?? "accent";
            const isCurrent = step.state === "current";
            const barCls = [
                styles.bar,
                styles[step.state],
                isCurrent ? TONE_BAR_CLASS[tone] : "",
            ]
                .filter(Boolean)
                .join(" ");
            const nameCls = [
                styles.name,
                styles[`name-${step.state}`],
                isCurrent ? TONE_NAME_CLASS[tone] : "",
            ]
                .filter(Boolean)
                .join(" ");
            return (_jsx("li", { className: styles.step, "aria-current": isCurrent ? "step" : undefined, children: _jsxs("button", { type: "button", className: styles.stepBtn, disabled: step.disabled, onClick: () => onStepClick?.(index), "aria-label": step.ariaLabel ?? step.label, children: [_jsx("span", { className: barCls, "aria-hidden": "true" }), _jsx("span", { className: nameCls, children: step.label })] }) }, `${step.label}-${index}`));
        }) }));
}
//# sourceMappingURL=Stepper.js.map